export default __webpack_public_path__ + "static/enter-prize-draw-1519e3a08c2fe17c2d9e8297cf70e447.png";